import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import CampaignCreate from './pages/CampaignCreate';
import Materials from './pages/Materials';
import Tasks from './pages/Tasks';
import AutoRules from './pages/AutoRules';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import BusinessManagers from './pages/BusinessManagers';
import DeveloperAccounts from './pages/DeveloperAccounts';
import CampaignTemplates from './pages/CampaignTemplates';
import AdSeriesTemplates from './pages/AdSeriesTemplates';
import AdCreation from './pages/AdCreation';
import AdCreationDrafts from './pages/AdCreationDrafts';
import CreativeCopyLibrary from './pages/CreativeCopyLibrary';
import MaterialCollections from './pages/MaterialCollections';
import FbUsers from './pages/FbUsers';
import PublicPages from './pages/PublicPages';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="campaigns/create" element={<CampaignCreate />} />
              <Route path="materials" element={<Materials />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="auto-rules" element={<AutoRules />} />
              <Route path="reports" element={<Reports />} />
              <Route path="settings" element={<Settings />} />
              <Route path="business-managers" element={<BusinessManagers />} />
              <Route path="public-pages" element={<PublicPages />} />
              <Route path="developer-accounts" element={<DeveloperAccounts />} />
              <Route path="fb-users" element={<FbUsers />} />
              <Route path="campaign-templates" element={<CampaignTemplates />} />
              <Route path="ad-series-templates" element={<AdSeriesTemplates />} />
              <Route path="ad-creation" element={<AdCreation />} />
              <Route path="ad-creation/drafts" element={<AdCreationDrafts />} />
              <Route path="creative-copy" element={<CreativeCopyLibrary />} />
              <Route path="material-collections" element={<MaterialCollections />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
